import React from 'react';
import Hotels from './Hotels';

const HomeStay = () => {
  // Same UI as Hotels page, default filter to Homestay & Villas
  return (
    <Hotels initialCategory="villa,homestay" hideCategoryFilters={false} />
  );
};

export default HomeStay;
